export default __webpack_public_path__ + "static/media/homeless_&_birds.c3a28122.jpg";